import React from 'react';
import { Controller } from 'react-hook-form';

import { MezzaFormField, MezzaFormFieldProps } from '../MezzaForm';
import { inputLabels } from '../../../data/labels';
import Input from '../../Input/Input';

const StreetType = ({ control, formState }: MezzaFormFieldProps) => {
  return (
    <Controller
      control={control}
      name={MezzaFormField.STREET_TYPE}
      rules={{ required: 'Kötelező mező!' }}
      render={({ field }) => (
        <Input
          id={MezzaFormField.STREET_TYPE}
          value={field.value}
          setValue={field.onChange}
          label={inputLabels.streetType}
          error={
            formState.errors[MezzaFormField.STREET_TYPE]?.message
              ? `${formState.errors[MezzaFormField.STREET_TYPE]?.message}`
              : ''
          }
        />
      )}
    />
  );
};

export default React.memo(StreetType);
